import React from "react"
import { formatMoney, formatDateTime } from "../transactions/format"

// Lifetime net + recent transactions for the merchant (doc 06 detail). Money is
// per-row currency (no FX blending — doc 09 #5).
export function RevenuePanel({ transactions, lifetimeNetCents, copy }) {
  const c = copy.revenue
  return (
    <div className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-6">
      <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{c.heading}</h2>
      <div className="mt-3">
        <div className="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">{c.lifetime}</div>
        <div className="mt-1 text-2xl font-bold tabular-nums text-gray-900 dark:text-gray-100">
          {formatMoney(lifetimeNetCents, "USD")}
        </div>
      </div>
      <h3 className="mt-5 text-sm font-semibold text-gray-700 dark:text-gray-300">{c.recent}</h3>
      {transactions.length === 0 ? (
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">{c.empty}</p>
      ) : (
        <ul className="mt-2 divide-y divide-gray-100 dark:divide-gray-800">
          {transactions.map((t) => (
            <li key={t.id} className="flex items-center justify-between py-2 text-sm">
              <span className="text-gray-700 dark:text-gray-300">{t.type}</span>
              <span className="text-xs text-gray-400 dark:text-gray-500">{formatDateTime(t.processed_at)}</span>
              <span className="tabular-nums font-medium text-gray-900 dark:text-gray-100">
                {formatMoney(t.net_cents, t.currency)}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
